import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import VxeTable from 'vxe-table';
import 'vxe-table/lib/style.css';
import 'mcf-shared/styles';

import App from './App.vue';
import router from './router';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(ElementPlus);
app.use(VxeTable);

app.mount('#app');